export const REGEX = {

    "DATE": "[0-9]{4}-[0-9]{2}-[0-9]{2}",
};